export class Constant {
  static readonly OK = 'OK';
  static readonly NG = 'NG';
  static readonly VersionNG = 'VersionNG';
  static readonly MaintenanceNG = 'MaintenanceNG';
  static readonly NetworkError = 'Network Error';
  static readonly timeoutError = 'timeout';
  static readonly timeoutErrorCode = 504;
  static readonly newMode = 'new';
  static readonly editMode = 'edit';

  // ローカルストレージのキー
  static readonly lsCompanyCode = 'lsCompanyCode';
  static readonly lsCompanyName = 'lsCompanyName';
  static readonly lsUsername = 'lsUsername';
  static readonly lsLoginStatus = 'lsLoginStatus';
  static readonly lsOperator = 'lsOperator';
  static readonly lsTrue = 'true';
  static readonly lsFalse = 'false';
  static readonly lsAuthCode = 'lsAuthCode';

  // API名
  static readonly apiNameCompany = 'company';
  static readonly apiTimeoutSecond = 30000;

  static readonly pcMsgComfirmDel = 'マスタを削除すると、データの閲覧・検索・集計などに影響が出る場合があります。\n<span style="color: red;">削除されたマスタは元に戻せませんので、慎重に操作してください。</span>';

  // アカウント管理？
  static readonly joTypeAdd = 'アカウント追加';
  static readonly joTypeEdit = '権限変更';

  // ダイアログ
  static readonly dialogWidth = '400px';
  static readonly accountEditDialogWidth = '460px';
  static readonly accountEditDialogHeight = '200px';
  static readonly accountEditDialogMaxHeight = '100px';
  static readonly managerEditDialogWidth = '1024px';

  // URL
  static readonly footerUrlPrivacy = 'https://unionnest.jp/privacy';
  static readonly footerUrlAgreement = 'https://unionnest.jp/terms';
  static readonly unionestSignupUrl = 'https://unionnest.jp/signup/';

  // メッセージ
  static readonly msgNetworkError = '通信に失敗しました。通信環境をご確認の上、再度実行するか、ページを更新してください。';
  static readonly msgLoginFailed = 'ログインに失敗しています。';
  static readonly msgMailOrPassEmpty = 'IDとパスワードは両方入力してください。';
  static readonly msgMailOrPassWrong =
    'ID、パスワード、ログインURL、いずれかが正しくありません。';
  static readonly msgFormInvalid = 'エラーを修正してください。';
  static readonly msgAccountExpired = 'アカウントの有効期限が切れています。管理者にお問い合わせください。';
  static readonly msgPassInvalid = '※英字と数字の組み合わせ、8桁以上';
  static readonly msgIdInvalid = '※半角、8桁以上';
  static readonly msgPassChangeError = 'パスワードを変更できませんでした。再度ログインしてください。';
  static readonly msgAccountCreateError = 'アカウントの作成に失敗した可能性があります。\n再度お手続きください。';
  static readonly msgAccountIdDuplicateError = 'このIDはすでに登録されています。';
  static readonly msgAccountCreateSuccess = 'アカウントを作成しました。';
  static readonly msgLoginAttemptExceeded = '連続してログインに失敗した為、一時的にログインが制限されています。';
  static readonly msgCopySuccess = 'コピーしました。';
  static readonly msgCopyError = 'コピーに失敗しました。';
  static readonly msgCopyErrorRetry = 'コピーに失敗した可能性があります。通信状況をご確認の上、再度実行してください。';
  static readonly msgNoticeNew = '作成しました。';
  static readonly msgNoticeDelConfirm = '削除します。\nよろしいですか？';
  static readonly msgNoticeDel = '削除しました。';
  static readonly msgNoticeDelFailed = '削除に失敗した可能性があります。通信状況をご確認の上、再度実行してください。';
  static readonly msgResultSaveSuccess = '保存しました。';
  static readonly msgResultpasswordResetSuccess = 'パスワードをリセットしました。';
  static readonly msgResultDeleteSuccess = '削除しました。';
  static readonly msgResultChangerUserAuthSuccess = '保存しました。';
  static readonly msgSaveFailedRetry = '失敗した可能性があります。\nページを更新してご確認ください。';
  static readonly msgErrorInvalidFile = 'ファイル形式が違います。';
  static readonly msgErrorLargeFile = 'ファイルが大きすぎます。';
  static readonly msgErrorUploadFile = 'ファイルのアップロードに失敗しました。ファイルを選択し直してください。';
  static readonly msgFileDownloadError = 'ファイルのダウンロードに失敗しました。ファイル取得元のページを更新して再度実行してください。';
  static readonly msgDeleteContentAlreadyError = 'この記事は削除済です。';  // TODO: 使われていますが、メッセージが間違っていないか？
  static readonly msgDeleteAccountAlreadyError = 'このアカウントは削除済です。';
  static readonly msgDeleteApprovalAccountError = 'ステータス「確認中」のMYイベントがあるため、アカウント削除できません。';
  static readonly msgRequestDeleteAccountAlreadyError = '削除済のアカウントが含まれています。';
  static readonly msgConfirmBack = '前のページに戻ります。\n保存していない内容は失われます。'
  static readonly msgSurveyAnswerFailedRetry = '回答に失敗した可能性があります。通信状況をご確認の上、再度実行してください。';
  static readonly msgSurveyAlreadyAnswered = '対象月のアンケートには既に回答済みです。'; // 048-SurveyAnswerPostのエラーメッセージと一致させること
  static readonly msgSurveyAnsweredDisplay = 'アンケートは回答済です。';
  static readonly msgSurveyAnswerSuccess = '回答しました。<br>ご協力ありがとうございました。'; // トーストはenableHtml:trueのため\nではなく<br>で改行する
  static readonly msgSurveyAnswerCancelConfirm = '一覧ページに戻ります。\n入力中の内容は失われます。';
  static readonly msgSurveyAnswerSubmitConfirm = 'アンケートを回答します。\n<span style="color:#EF4444">回答後の変更はできません。</span>';
  // 以下は048-SurveyAnswerPostが返しうる業務エラーメッセージ（フロントの入力チェックをすり抜けた場合の
  // レース・不整合用）。APIレスポンスの文字列をそのまま画面表示せず、既知の文言かどうかを判定して
  // 表示するために定義する（enableHtml:trueのトーストへ任意の文字列を流し込まないため）
  static readonly msgSurveyAnswerPeriodOver = '回答期間を過ぎています。'; // 048-SurveyAnswerPostのエラーメッセージと一致させること
  static readonly msgSurveyInvalidAnswer = '回答内容に不正な値が含まれています。'; // 048-SurveyAnswerPostのエラーメッセージと一致させること
  static readonly msgSurveyWorkplaceScopeRequired = '回答する職場/店舗の範囲を選択してください。'; // 048-SurveyAnswerPostのエラーメッセージと一致させること
  static readonly msgSurveyWorkplaceRequired = '回答する職場/店舗を選択してください。'; // 048-SurveyAnswerPostのエラーメッセージと一致させること
  static readonly msgSurveyPartDetailsRequired = 'その範囲の組合員数と勤務範囲の名称を入力してください。'; // 048-SurveyAnswerPostのエラーメッセージと一致させること
  static readonly msgSurveyAnswerReminderSuffix = '月分の90秒アンケートが未回答です。<br />24日までに回答してください。';
  static readonly msgErrorReturn = '差戻し対象がありません';
  static readonly msgErrorApplove = '決裁対象がありません';
  static readonly msgFailedApprovalFlow = '別のユーザが対応済です。';
  static readonly msgConfirmDelTalenttag = '職場/店舗タグを「削除」すると、削除したタグが<span style="color: #EF4444;">全てのマスタ情報から消失</span>します。\n\nこの操作は戻せません。よろしいですか。';
  static readonly msgResultSaveFailed = '保存に失敗しました。';

  // ページタイトル
  static readonly pageTitleRoot = 'UNION NEST';
  static readonly pageTitleCommon = '｜UNION NEST';
  static readonly pageTitleLogin = 'ログイン';
  static readonly pageTitlePasswordChange = 'パスワード変更';
  static readonly pageTitleCreateAccount = 'アカウント作成';
  static readonly pageTitleAccountAbout = '個人設定';
  static readonly pageTitleMasterSettings = 'マスタ設定';
  static readonly pageTitleOrganizationAbout = '組織情報';
  static readonly pageTitleOrganizationaccount = 'アカウント管理';
  static readonly pageTitleError = 'エラーページ';
  static readonly pageTitleTerms = '利用規約';
  static readonly pageTitlePrivacy = 'プライバシーポリシー';
  static readonly pageTitleMaintenance = 'メンテナンス';
  static readonly pageTitleMyEvent = 'MYイベント';
  static readonly pageTitleSearchEvent = 'イベント検索';
  static readonly pageDescriptionRoot = 'UNION NESTは組合運営総合支援システムです。組合の日々の活動を未来につながる資産に変え、労働組合の組織力を向上させます。';

  // MYイベント
  static readonly myEventHoldingUnits = [
    { value: 'headquarters', label: '本部' },
    { value: 'branch_area', label: '支部/エリア' },
    { value: 'block', label: 'ブロック' },
    { value: 'workplace_store', label: '職場/店舗' },
    { value: 'combined', label: '複合' },
  ];
  static readonly myEventDocumentTypes = {
    plan: '企画書',
    report: '報告書',
  };
  static readonly myEventStatuses = {
    draft: '下書き',
    reviewing: '確認中',
    returned: '確認中',
    completed: '完了',
    before_draft: '下書き',
  };
  static readonly myEventApprovalStatuses = {
    not_started: '未着手',
    reviewing: '確認中',
    approved: '承認済',
    returned: '差戻し',
    submitted: '承認依頼日'
  };
  // MYイベント一覧（起票／承認）の1ページあたり件数
  static readonly myEventPageSize = 20;

  // 組合相談
  static readonly apiPathUnionConsultation = '/union-consultation';
  static readonly ucPageSize = 20;
  static readonly evPageSize = 50;
  static readonly ucSummaryTruncateLen = 116;
  // 組合相談一覧のカードの緊急度の帯（event_master uc_urgency の名前 → 帯の文字・赤にするか）。通常・低いは帯を出さない
  static readonly ucUrgencyBadges: { [name: string]: { label: string; high: boolean } } = {
    '非常に高い': { label: '超緊急', high: true },
    '高い': { label: '緊急', high: false },
  };
  static readonly ucMaxSessions = 10;
  static readonly ucMaxAttachments = 3;
  static readonly ucAttachmentMaxSize = 10485760; // 10MB

  // 90秒アンケート 一覧（無制限ローディング）
  static readonly surveyListPageSize = 36;
  static readonly ucAttachmentAccept = 'application/pdf,image/jpeg,image/png,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  static readonly pageTitleUnionConsultation = '組合相談';
  static readonly pageTitleSurvey = '90秒アンケート';
  static readonly pageTitleSurveyAnswer = '90秒アンケート回答';
  static readonly pageTitleSurveyReport = '90秒アンケートレポート';

  // チャットbot
  static readonly apiPathChat = '/chat';
  static readonly fvMaxChatInput = 500;
  static readonly msgChatTitle = 'UNION NEST使い方サポート';
  static readonly msgChatGreeting = 'AIによる自動応答です。内容によってはお答えできない場合があります。';
  static readonly msgChatPlaceholder = '質問を入力してください';
  static readonly msgChatOpen = 'UNION NEST使い方サポートを開く';
  static readonly msgChatClose = '閉じる';
  static readonly msgChatSend = '送信';

  // CaLinの情報
  static readonly calinTellNo = '03-5324-2271';
  static readonly calinWorkTime = '（平日10～18時）';
  static readonly calinSupportMail = 'support@leadfor.jp';

  // ルーティング
  static readonly rtPrContentsCategory = 'pr_contents/category';
  static readonly rtMaterials = 'materials';
  static readonly rtAnalytics = 'analytics';
  static readonly rtRequest = 'request';
  static readonly rtLpNewgrad = 'newgrad';
  static readonly rtLpCareer = 'career';
  static readonly rtCase = 'case';
  static readonly rtTmpFile = 'tmpfile';
  static readonly rtMsgFile = 'msgfile';
  static readonly rtAttachment = 'attachment';
  static readonly rtQuestion = 'question';
  static readonly rtDownload = 'download/LEADFOR_whitepaper';
  static readonly rtImportTalent = 'import/talent';

  // 共通
  static readonly toastShowMiliSec = 3000;
  static readonly toastShowMiliSecErr = 4000;
  static readonly imageFormatJpg = 'image/jpeg';
  static readonly imageFormatPng = 'image/png';
  static readonly fileFormatCsv = 'text/csv';
  static readonly fileFormatPdf = 'application/pdf';
  static readonly fileFormatPpt = 'application/vnd.ms-powerpoint';
  static readonly fileFormatPptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  static readonly fileFormatXls = 'application/vnd.ms-excel';
  static readonly fileFormatXlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  static readonly fileFormatDoc = 'application/msword';
  static readonly fileFormatDocx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  static readonly fileFormatZip = 'application/zip';
  static readonly fileFormatZipWin = 'application/x-zip-compressed';
  static readonly fileFormatBinary = 'binary/octet-stream';
  static readonly fileFormatDownload = 'application/octet-stream';
  static readonly fileExtensionPdf = 'pdf';
  static readonly fileExtensionPng = 'png';
  static readonly fileExtensionJpg = 'jpg';
  static readonly fileExtensionJpeg = 'jpeg';
  static readonly fileMaxSize = 5242880;
  static readonly fileTalentMaxSize = 30000000;
  static readonly fileTypeAttached = 'image/png,image/jpeg,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip';
  static readonly empty = '';
  static readonly pythen = '-';
  static readonly commma = '、';
  static readonly hsCommma = ',';
  static readonly slash = '/';
  static readonly monthJan = '01';
  static readonly dateFirst = '01';
  static readonly coron = ':';
  static readonly sharp = '#';
  static readonly pipe = '|';
  static readonly prefixRequire = '※必須';
  static readonly prefixOnlyNumber = '※半角数字';
  static readonly prefixOnlyNumberAD = '※半角数字・西暦';
  static readonly prefixFormatPngJpg = '※png/jpg';
  static readonly prefixMultiSelectEnable = '※複数選択可';
  static readonly prefixRequireMark = '※';
  static readonly prefixYear = '年';
  static readonly prefixPeople = '人';
  static readonly prefixYen = '円';
  static readonly prefixImageTriming165 = '16:5サイズに自動トリミングされます';
  static readonly prefixImageTriming169 = '16:9サイズに自動トリミングされます';
  static readonly textNotRegist = '未登録';
  static readonly modeEdit = 'edit';
  static readonly modeAdd = 'add';
  static readonly modeDel = 'del';
  static readonly uploadImageWidth = 1200;
  static readonly uploadImageHeight = 1200;
  static readonly uploadImageFullWidth = 1920;
  static readonly uploadImageFullHeight = 1080;
  static readonly flagOn = 1;

  static readonly tagEditDialogWidth = '500px';
  static readonly tagEditDialogHeight = '600px';

  static readonly surveyWorkplaceDialogWidth = '600px';
  // 「○○月分の90秒アンケートが未回答です。」（15px）が1行に収まる幅
  static readonly surveyAnswerReminderDialogWidth = '320px';

  // バリデーション
  static readonly vlInvalidYear = '年';
  static readonly vlInvalidMonth = '月';
  static readonly vlInvalidNumber = '無効な数値です';
  static readonly fvActiveStartYear = 2018;
  static readonly fvMinYear = 1930;
  static readonly fvMaxYear = 2017;
  static readonly fvMinMonth = 1;
  static readonly fvMaxMonth = 12;
  static readonly fvMinDay = 1;
  static readonly fvMaxDay = 31;
  static readonly fvMaxMemo = 10000;
  static readonly fvMaxCompanyName = 50;
  static readonly fvMaxLenHistoryActivity = 2000;
  static readonly fvMaxLenIncome = 5;
  static readonly fvMaxSurveyPartMemberCount = 5;
  static readonly fvMaxSurveyPartName = 50;
  static readonly fvAlpahNumericReg = /^[a-z0-9]*$/;
  static readonly tfStartYear = 'start_year';
  static readonly tfStartMonth = 'start_month';
  static readonly tfEndYear = 'end_year';
  static readonly tfEndMonth = 'end_month';
  static readonly msgErrorInputAllTerm = '%sを登録する場合は全て入力してください。';
  static readonly msgErrorInputAllTerm2 = '期間は全て入力してください。';
  static readonly msgErrorInputStartDate = '年と月は両方入力してください。期初の年月は必須です。';
  static readonly msgErrorInvalidType = '正しい形式で入力してください。';
  static readonly msgErrorInvalidAddress = '都道府県を選択してください。';

  // ==================== イベント検索 絞込・ソート ====================
  // 絞込条件タイプ
  static readonly esConditionTypeCategoryMajor = 'CATEGORY_MAJOR';
  static readonly esConditionTypeCategorySub = 'CATEGORY_SUB';
  static readonly esConditionTypePurpose = 'PURPOSE';
  static readonly esConditionTypeSocialTheme = 'SOCIAL_THEME';
  static readonly esConditionTypeImproveState = 'IMPROVE_STATE';
  static readonly esConditionTypeImproveOutcome = 'IMPROVE_OUTCOME';
  static readonly esConditionTypeOrganizerUnit = 'ORGANIZER_UNIT';
  static readonly esConditionTypeParticipantCategory = 'PARTICIPANT_CATEGORY';
  static readonly esConditionTypeKeywordTitle = 'KEYWORD_TITLE';
  static readonly esConditionTypeKeywordSummary = 'KEYWORD_SUMMARY';
  static readonly esConditionTypeScopeOrg = 'SCOPE_ORG';

  // チップ結合方法（同一タイプ内はOR。タイプをまたぐ場合は連結せずAND扱い）
  static readonly esConnectOr: 'OR' = 'OR';

  // ソート
  static readonly esOrderNewest: 'NEWEST' = 'NEWEST';
  static readonly esOrderEvalScore: 'EVAL_SCORE' = 'EVAL_SCORE';
  static readonly esOrderParticipants: 'PARTICIPANTS' = 'PARTICIPANTS';
  static readonly esOrderSelect = [
    { value: Constant.esOrderNewest, label: '新着順' },
    { value: Constant.esOrderEvalScore, label: '参加者評価順' },
    { value: Constant.esOrderParticipants, label: '参加人数順' },
  ];

  // 検索範囲（作成組織）
  static readonly esScopeOwn = 'own';
  static readonly esScopeOther = 'other';

  // キーワード入力制限
  static readonly esKeywordMaxLen = 20;
  static readonly esKeywordMaxCount = 5;

  // event_master の master_type（バックエンドと共有する文字列）
  static readonly esMasterTypeCategoryMajor = 'category_major';
  static readonly esMasterTypeCategorySub = 'category_sub';
  static readonly esMasterTypePurpose = 'purpose';
  static readonly esMasterTypeSocialTheme = 'social_theme';
  static readonly esMasterTypeImproveState = 'improvement_indicator_state';
  static readonly esMasterTypeImproveOutcome = 'improvement_indicator_outcome';
  static readonly esMasterTypeOrganizerUnit = 'organizer_org_unit';
  static readonly esMasterTypeParticipantCategory = 'participant_category';

}
